import { render, staticRenderFns } from "./stdBalanceReport.vue?vue&type=template&id=fc50dc16&scoped=true&"
import script from "./stdBalanceReport.vue?vue&type=script&lang=js&"
export * from "./stdBalanceReport.vue?vue&type=script&lang=js&"
import style0 from "./stdBalanceReport.vue?vue&type=style&index=0&id=fc50dc16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc50dc16",
  null
  
)

export default component.exports